import TotalsLine from '../common/list/TotalsLine';
import { getNumberComma } from '../../utils/numberUtils';

// 합계 줄(총매출액/총매입액/매출이익/이익률). 값/로직은 그대로, 렌더는 공통 TotalsLine(2026-10-22).
const ChanceTotalSummary = ({ totals }) => {
  const margin = totals?.totalMargin;
  const marginValue = parseFloat(margin);
  const marginColor =
    !isNaN(marginValue) && marginValue > 20
      ? 'success.main'
      : !isNaN(marginValue) && marginValue < 10
      ? 'error.main'
      : 'text.primary';

  const items = [
    { label: '총매출액', value: getNumberComma(totals?.totalSales) },
    { label: '총매입액', value: getNumberComma(totals?.totalPurchase) },
    { label: '매출이익', value: getNumberComma(totals?.totalProfit) },
    { label: '이익률', value: `${getNumberComma(margin)} %`, color: marginColor },
  ];

  return <TotalsLine items={items} />;
};

export default ChanceTotalSummary;
